<template>
  <div>
    <el-card>
      <div class="flex" style="justify-content: flex-end; margin-bottom: 20px">
        <el-button type="primary" round @click="SaveManageTypeList"
          >保存</el-button
        >
      </div>
      <draggable
        v-model="tableData"
        chosenClass="chosen"
        forceFallback="true"
        group="people"
        animation="500"
      >
        <transition-group>
          <div v-for="item in tableData" :key="item.Id" class="tui-drag">
            <div class="tui-dragItme">
              <div class="flex-items">
                <img :src="item.Icon" alt="" />
                <div class="name">{{ item.Name }}</div>
              </div>
              <el-switch
                v-model="item.IsOpen"
                :active-value="1"
                :inactive-value="0"
                :disabled="userInfo.UserIdentity.indexOf('2') != -1"
                @change="onChangeSwitch($event, item)"
              >
              </el-switch>
            </div>
          </div>
        </transition-group>
      </draggable>
    </el-card>
  </div>
</template>
<script>
import { GetManageTypeList, SaveManageTypeList } from "../../api/api";
import draggable from "vuedraggable";

export default {
  components: { draggable },
  data() {
    return {
      tableData: [],
      userInfo: {},
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.GetManageTypeList();
  },
  methods: {
    async SaveManageTypeList() {
      let res = await SaveManageTypeList({
        list: this.tableData,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.GetManageTypeList();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    onChangeSwitch(e, item) {
      item.IsOpen = e;
    },
    async GetManageTypeList() {
      let res = await GetManageTypeList();
      if (res.data.success) {
        this.tableData = res.data.response;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tui-drag {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  .tui-dragItme {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    img {
      width: 30px;
      height: 30px;
    }
    .name {
      font-size: 18px;
      padding-left: 10px;
    }
  }
}
.el-card {
  width: 25%;
  margin-bottom: 20px;
}
</style>